module.exports = __webpack_public_path__ + "img/p5.88790386.png";